import { QueryHookOptions } from '@apollo/client'
import {
  GetIntegrationsDocument,
  GetIntegrationsQuery,
  GetIntegrationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Integration = GetIntegrationsQuery['ats']['integrationsConnection']['nodes']
type Options = QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>

export const useIntegration = (options?: Options) => {
  const { data, loading } = useQuery(GetIntegrationsDocument, options)

  const nodes = data?.ats.integrationsConnection.nodes

  return {
    loading,
    integration: nodes ? nodes[0] : undefined,
  }
}
